var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[_vm.oicon, _vm.osize]})}
var staticRenderFns = []

export { render, staticRenderFns }